import axios from 'axios';

class ContatoService {

    enviarEmail(obj) {
        return axios.post(process.env.PUBLIC_URL + "/enviaremail", obj);
    }
}

export default new ContatoService();